import { supabase } from "@/integrations/supabase/client";

export interface DbRemediationTemplate {
  finding_title: string;
  priority_level: string;
  recommended_action: string;
  timeframe: string;
  recommended_measures: string;
  remediation_path: string;
  risk_level: string;
}

export function getScoreLevelFromScore(score: number | null): string | null {
  if (score === null || score === undefined) return null;
  if (score <= 25) return "NOT_IMPLEMENTED";
  if (score <= 75) return "PARTIALLY_IMPLEMENTED";
  return "IMPLEMENTED";
}

export async function fetchRemediationTemplate(
  controlCode: string,
  score: number | null,
  questionnaireKey: string = "telecom_v2"
): Promise<DbRemediationTemplate | null> {
  const scoreLevel = getScoreLevelFromScore(score);
  if (!scoreLevel) return null;

  const { data, error } = await (supabase as any).rpc("get_remediation_template", {
    p_questionnaire_key: questionnaireKey,
    p_control_code: controlCode,
    p_score_level: scoreLevel,
  });

  if (error || !data || data.length === 0) return null;
  return data[0] as DbRemediationTemplate;
}
